import { store, getContext } from '@wordpress/interactivity';


function navWithQueryParams(
  serializedFormValues,
  searchStartValue = window.location.search,
) {
  const queryParams = new URLSearchParams(searchStartValue);
  Object.keys(serializedFormValues).forEach((queryParamKey) => {
    const queryParamValue = serializedFormValues[queryParamKey];

    if (queryParamValue === null) {
      queryParams.delete(queryParamKey);
    } else {
      queryParams.set(queryParamKey, queryParamValue);
    }
  });

  const queryString = queryParams.toString().length > 0
    ? `?${queryParams.toString()}`
    : ``;
  
  const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${queryString}`;
  console.log(`Refreshing to URL: ${newUrl}`)
  window.location.href = newUrl;
}

const { state, actions } = store('amplifyQueryFilter', {
  context: {
    // Note: these are just placeholders, they'll be replaced by dynamic
    // values from the render script.
    queryId: null,
    serializedFormValues: {},
    initFormValues: {},
  },

  state: {
    get hasQueryId() {
      const context = getContext();
      return context.queryId !== null && Number.isInteger(context.queryId);
    },
  },

  actions: {
    onClear: () => {
      console.log(`[onClear] Clearing local form filters...`)

      if (state.hasQueryId) {
        const context = getContext();

        // Create a bundle that the form values we currently have set, but 
        // mark all as "blank" with null values.
        const emptyFormValues = Object.keys(context.serializedFormValues).reduce((acc, key) => {
          acc[key] = null;
          return acc;
        }, {});

        console.log(`Clearing all filters for query ${context['queryId']} with empty values:`, emptyFormValues)

        navWithQueryParams(emptyFormValues);
      }
    },

    onReset: () => {
      console.log(`[onReset] Resetting!`)
      
      if (state.hasQueryId) {
        const context = getContext();

        console.log(`Resetting filter changes for query ${context['queryId']} with values:`, context.initFormValues)

        navWithQueryParams(context.initFormValues);
      }
    },
      
    onSubmit: () => {
      console.log(`[onSubmit] Submit button clicked!`)

      if (state.hasQueryId) {
        const context = getContext();
        
        console.log(`Filtering query ${context['queryId']} with values:`, context.serializedFormValues)

        navWithQueryParams(context.serializedFormValues);
      }
    },
  },
});
